import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';

const MainButton = ({ href, onClick, text, type }) => {
  return (
    <div data-testid="mainButton">
      <a className={styles.link} href={href} onClick={onClick}>
        <div className={classNames(styles.container, styles[type])}>
          <span className={styles.text}>{text}</span>
        </div>
      </a>
    </div>
  );
};

MainButton.defaultProps = {
  href: '/',
  onClick: undefined,
  type: 'default'
};

MainButton.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  type: PropTypes.string
};

export default MainButton;
